// react
import { Map, List, fromJS } from "immutable";

export const initialState = Map({
	deploymentInfo: Map(),
	deploymentsList: List(),
});

export default function deploymentsReducer(state = initialState, action) {
	switch (action.type) {
		case "DEPLOYMENTS:GET@SUCCESS": {
			return state.withMutations((mutable) => {
				mutable.setIn(["deploymentsList"], action.response.get("deployments"));
			});
		}

		case "DEPLOYMENTS:UPDATEDOMAIN": {
			return state.withMutations((mutable) => {
				mutable.setIn(["deploymentInfo", action.domain], fromJS(action.domainData));
			});
		}

		default:
			return state;
	}
}
